import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Onboarding from "@/pages/Onboarding";
import AppShell from "@/components/AppShell";
import Dashboard from "@/pages/Dashboard";
import Appointments from "@/pages/Appointments";
import Customers from "@/pages/Customers";
import Calls from "@/pages/Calls";
import Services from "@/pages/Services";
import Hours from "@/pages/Hours";
import AISettings from "@/pages/AISettings";
import TestReceptionist from "@/pages/TestReceptionist";
import Analytics from "@/pages/Analytics";
import TrialRecap from "@/pages/TrialRecap";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Knowledge from "@/pages/Knowledge";
import Business from "@/pages/Business";
import AuditLog from "@/pages/AuditLog";
import Settings from "@/pages/Settings";
import Team from "@/pages/Team";
import Admin from "@/pages/Admin";
import "@/App.css";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/onboarding" element={<Protected><Onboarding /></Protected>} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/app" element={<Protected><AppShell /></Protected>}>
            <Route index element={<Dashboard />} />
            <Route path="dashboard" element={<Navigate to="/app" replace />} />
            <Route path="appointments" element={<Appointments />} />
            <Route path="customers" element={<Customers />} />
            <Route path="calls" element={<Calls />} />
            <Route path="services" element={<Services />} />
            <Route path="hours" element={<Hours />} />
            <Route path="ai" element={<AISettings />} />
            <Route path="test" element={<TestReceptionist />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="recap" element={<TrialRecap />} />
            <Route path="knowledge" element={<Knowledge />} />
            <Route path="business" element={<Business />} />
            <Route path="audit" element={<AuditLog />} />
            <Route path="settings" element={<Settings />} />
            <Route path="admin" element={<Admin />} />
            <Route path="team" element={<Team />} />
            <Route path="*" element={<Navigate to="/app" replace />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
